import React from 'react';
import classNames from 'classnames';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import i18next from '../../../../config/i18next';


import {
  Button,
} from '../../../../components';

import './style.scss';

const PersonCard = ({ id, entity, className }) => {
  const classes = classNames(className);
  const imageMedium = entity.getIn(['field_image', 0, 'styles', 'medium']);
  const imageLarge = entity.getIn(['field_image', 0, 'styles', 'large']);

  const title = entity.getIn(['title', 0, 'value']);
  const jobTitle = entity.getIn(['field_job_title', 0, 'value']);

  const phoneNumber = entity.getIn(['field_phone_number', 0, 'value']);
  const email = entity.getIn(['field_email', 0, 'value']);

  const facebook = entity.getIn(['field_facebook', 0, 'uri']);
  const twitter = entity.getIn(['field_twitter', 0, 'uri']);
  const linkedin = entity.getIn(['field_linkedin', 0, 'uri']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="PersonCard mb-6">
        <div className="PersonCard__image">
          <Image
            src={{
              0: imageMedium,
              768: imageLarge,
            }}
            includeWebP
          />
        </div>

        <div className="PersonCard__info">
          <h4 className="PersonCard__title">{title}</h4>
          <div>{jobTitle}</div>
          {phoneNumber && (
            <div className="PersonCard__info__phone">
              {phoneNumber}
            </div>
          )}
          {
            facebook && (
              <a className="PersonCard__icon icon icon-facebook" target="_blank" rel="noopener noreferrer" href={facebook}>Facebook</a>
            )
          }
          {
            twitter && (
              <a className="PersonCard__icon icon icon-x" target="_blank" rel="noopener noreferrer" href={twitter}>X</a>
            )
          }
          {
            linkedin && (
              <a className="PersonCard__icon icon icon-linkedin" target="_blank" rel="noopener noreferrer" href={linkedin}>Linkedin</a>
            )
          }
        </div>

        <div className="PersonCard__contact">
          <Button
            primary
            href={`mailto:${email}`}
            className="PersonCard__contact__mail"
          >
            {i18next.t('person_card_email')}
          </Button>
          <Button
            primary
            href={`tel:${phoneNumber}`}
            className="PersonCard__contact__phone"
          >
            Bellen
          </Button>
        </div>
      </div>
    </article>
  );
};

export default PersonCard;
